<template>
  <div class="post-wall-card-top">
    <!-- 頭貼 -->
    <div class="user-img">
      <img :src="headShot || defaultImg" @error="setDefaultImg()" />
    </div>
    <div class="card-right">
      <div class="card-right-top">
        <!-- 名字 -->
        <div class="user-name">
          {{ postCardTopData.MemObj.NickName }}
          <!-- 被 tag 的人 -->
          <span v-if="tagNameList.length > 0">
            與 {{ tagNameList[0] }}
            <!-- #SlideUpDialog-function @click="dialog = true" 開啟 SlideUpDialog -->
            <span v-if="tagNameList.length > 1" class="others-p" @click="dialog = true">和其他 {{ tagNameList.length - 1 }} 人</span>
          </span>
          <!-- 顯示其他朋友 (相關用法請搜尋關鍵字 #SlideUpDialog-function)-->
          <SlideUpDialog v-if="tagNameList.length > 0" :dialogData="otherTagData" @changeDisplay="changeDisplay"></SlideUpDialog>
        </div>
        <div class="fun-btn" @click="showTool(postCardTopData)"><i class="far fa-ellipsis-h"></i></div>
      </div>
      <div class="card-right-bottom row" :class="unitClass()">
        <!-- 發文時間 -->
        <div class="post-time row">
          <div class="q-mr-xs"><i :class="checkPostVisibleIcon"></i></div>
          <div class="">{{ postTime }}</div>
        </div>
        <!-- 讚數 -->
        <div v-if="postCardTopData.LikeCount > 0" class="great-amount-div">
          <img src="@/assets/img/icon_goodblue.png" />
          <span class="great-amount">
            {{ postCardTopData.LikeCount }}
            <span class="people-good-words" v-if="isShowGoodWords">人都說讚</span>
          </span>
        </div>
      </div>
    </div>
    <!-- alert -->
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-py-md" style="width: 90%">
        <q-card-section class="row items-center">
          <!-- alert 內容文字 -->
          <span class="q-ml-sm q-mx-auto text-center" v-html="qDialogData.dialogContent"></span>
        </q-card-section>
        <q-card-actions align="center" class="justify-around">
          <!-- alert 按鈕 -->
          <q-btn flat :label="qDialogData.leftButton" color="negative" @click="doFunction(postCardTopData)" v-close-popup />
          <q-btn flat :label="qDialogData.rightBotton" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SlideUpDialog from '@/components/SharedComponents/SlideUpDialog';
export default {
  name: 'PostWallCardTop',
  props: ['postCardTopData'],
  components: { SlideUpDialog },
  data() {
    return {
      confirm: false,
      // 是否要顯示按讚的中文 "幾人都說讚"
      isShowGoodWords: true,
      // 預設頭貼
      defaultImg: require('@/assets/img/defultPerson1.png'),
      // #SlideUpDialog-function (要使用 SlideUpDialog.vue 需在父層加此 dialog data)
      dialog: false,
      qDialogData: {
        type: '',
        dialogContent: '',
        leftButton: '刪除',
        rightBotton: '取消'
      }
    };
  },
  computed: {
    // 發文者頭像
    headShot: {
      get() {
        return this.postCardTopData.MemObj.HeadShot;
      },
      set(value) {
        this.setDefaultImg();
      }
    },
    // 發文時間單位整理
    postTime() {
      let unit = this.postCardTopData.DiffranceTime.unit;
      let num = this.postCardTopData.DiffranceTime.num;
      if (unit === 'date') {
        // 太長的日期格式就隱藏 "人都說讚"的中文字
        if (num.indexOf('年') > -1) {
          this.isShowGoodWords = false;
        }
        return num;
      } else if (unit === 'hour') {
        return num + '小時前';
      } else if (unit === 'minute') {
        return num + '分鐘前';
      }
    },
    // 判斷發文可視範圍 icon (ALL 所有人可見, FRIEND 僅朋友可見, ONLYME 自己可見)
    checkPostVisibleIcon() {
      if (this.postCardTopData.Visible === 'ONLYME') {
        return 'fas fa-user-lock';
      } else if (this.postCardTopData.Visible === 'ALL') {
        return 'fal fa-clock';
      } else if (this.postCardTopData.Visible === 'FRIEND') {
        return 'fas fa-user-friends';
      }
    },
    // 顯示其他被標記的人的 dialog 頁面所需要的資料
    otherTagData() {
      let contentData = [];
      let tagNameList;
      let tagAvatarList;
      // 區分是原創貼文 或 被分享的貼文
      if (this.postCardTopData.TagNicknameList) {
        tagNameList = this.postCardTopData.TagNicknameList;
        tagAvatarList = this.postCardTopData.TagAvatarList;
      } else {
        tagNameList = this.postCardTopData.ShareTagNicknameList;
        tagAvatarList = this.postCardTopData.ShareTagAvatarList;
      }
      // 顯示第二筆資料(因第一個人在貼文牆上已有顯示)
      for (let i = 1; i < tagNameList.length; i++) {
        contentData.push({
          index: i,
          name: tagNameList[i],
          avatar: tagAvatarList[i]
        });
      }
      // dialogData必要的 data (#SlideUpDialog-function)
      return {
        dialogDisplay: this.dialog, // 必要
        title: '其他被標記的對象', // 必要
        componentName: 'OtherTagList', // 必要
        contentData // SlideUpDialog 裡內容所引用的 component 所需的資料(非必要，視需求傳入)
      };
    },
    // 判斷是 第一次發文 或 分享他人的貼文(貼文內的貼文) 的"標記對象"
    tagNameList() {
      if (this.postCardTopData.TagNicknameList) {
        // 第一次發文
        return this.postCardTopData.TagNicknameList;
      } else if (this.postCardTopData.ShareTagNicknameList) {
        // 分享他人的貼文
        return this.postCardTopData.ShareTagNicknameList;
      }
    }
  },
  methods: {
    ...mapActions('PostWallModule', ['deleteApiPost', 'hideApiPost', 'hideAllApiPost', 'reportApiPost', 'reportUserApiPost']),
    // 顯示工具列
    showTool(target) {
      let config = {
        class: 'post-card-bottom-sheet',
        target,
        actions: [
          {
            id: 'deletePost',
            label: '刪除動態'
          },
          {
            id: 'hidePost',
            label: '隱藏該則動態'
          },
          {
            id: 'reportPost',
            label: '檢舉該則動態'
          },
          {
            id: 'hideAllPost',
            label: '隱藏此人全部動態'
          },
          {
            id: 'reportUserPost',
            label: '檢舉此用戶'
          },
          {
            id: 'cancel',
            label: '取消'
          }
        ]
      };

      // 判斷身分來顯示對應的功能
      if (this.postCardTopData.CanDelete) {
        // 若是自己發的文則 CanDelete 為　true，即可刪除動態
        config.actions.splice(1, 2);
      } else {
        // 別人發的文則可作隱藏或檢舉
        config.actions.splice(0, 1);
      }
      this.$q
        .bottomSheet(config)
        .onOk(action => {
          if (action.id === 'deletePost') {
            this.qDialogData = {
              type: action.id,
              dialogContent: '確定要刪除這則動態嗎?',
              leftButton: '刪除',
              rightBotton: '取消'
            };
            // 叫出確認視窗
            this.confirm = true;
          } else if (action.id === 'hidePost') {
            this.qDialogData = {
              type: action.id,
              dialogContent: '確定要隱藏這則動態嗎?</br>隱藏後未來將不再顯示這則動態。',
              leftButton: '確定',
              rightBotton: '取消'
            };
            // 叫出確認視窗
            this.confirm = true;
          } else if (action.id === 'hideAllPost') {
            this.qDialogData = {
              type: action.id,
              dialogContent: '確定要隱藏此人全部動態嗎?</br>隱藏後未來將不再顯示此人動態。',
              leftButton: '確定',
              rightBotton: '取消'
            };
            // 叫出確認視窗
            this.confirm = true;
          } else if (action.id === 'reportPost') {
            // 叫出檢舉視窗
            this.reportPost('post', config.target);
          } else if (action.id === 'reportUserPost') {
            // 叫出檢舉視窗
            this.reportPost('user', config.target);
          }
        })
        .onCancel(() => {
          console.log('Dismissed');
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },

    // SlideUpDialog 此子 component 用來關閉父 component 的 dialog (#SlideUpDialog-function)
    changeDisplay(childValue) {
      this.dialog = childValue;
    },

    // 判斷 alert 按下確認後所要執行的方法
    doFunction(target) {
      if (this.qDialogData.type === 'deletePost') {
        // 刪除貼文
        this.deleteApiPost(target.PostId);
      } else if (this.qDialogData.type === 'hidePost') {
        // 隱藏全部貼文
        this.hideApiPost(target.PostId);
      } else if (this.qDialogData.type === 'hideAllPost') {
        this.hideAllApiPost(target.MemObj.FriendLaleId);
      } else if (this.qDialogData.type === 'hideAllPost') {
        // 檢舉貼文
      }
    },
    // 檢舉動態
    reportPost(type, target) {
      this.$q
        .dialog({
          message: '檢舉這則動態的原因是?',
          class: 'report-dialog',
          color: 'negative',
          options: {
            type: 'radio',
            model: '',
            isValid: val => val !== '',
            items: [
              { label: '色情內容', value: 1, color: 'negative' },
              { label: '騷擾行為', value: 2, color: 'negative' },
              { label: '這主張暴力或傷害他人或動物', value: 3, color: 'negative' },
              { label: '因為不實的新聞報導', value: 4, color: 'negative' },
              { label: '其他原因', value: 100, color: 'negative' }
            ]
          },
          persistent: true,
          cancel: '取消',
          ok: '確定'
        })
        .onOk(data => {
          if (type == 'post') {
            const params = {
              reason: data,
              targetId: target.PostId
            };
            this.reportApiPost(params);
          } else if (type == 'user') {
            const params = {
              reason: data,
              targetId: target.MemObj.FriendLaleId
            };
            this.reportUserApiPost(params);
          }
          console.log('>>>> OK, received', data);
        });
    },

    // 死圖時給預設圖片
    setDefaultImg() {
      return (this.headShot = this.defaultImg);
    },

    // 判斷發文時間單位，來決定 css 如何呈現寬度
    unitClass() {
      let unit = this.postCardTopData.DiffranceTime.unit;
      let num = this.postCardTopData.DiffranceTime.num;
      if (unit === 'date') {
        if (num.indexOf('年') > -1) {
          return 'unit-year';
        }
        return 'unit-month';
      } else {
        return 'unit-big';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 當是被分享到別人貼文下的貼文會有不一樣的 UI
.share-card {
  .post-wall-card-top {
    border-left: 4px #e8e8e8 solid;
    padding: 10px 10px 2px 10px;
  }

  .fun-btn {
    display: none;
  }
}
// share-card END --------------------------
.user-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-block;
  margin-right: 12px;
}

.user-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-right {
  display: inline-block;
  width: calc(100% - 62px);
  vertical-align: top;
  font-size: 16px;
}

.card-right-top {
  width: 100%;
}

.user-name {
  width: calc(100% - 30px);
  display: inline-block;
  color: $LaleTitleBlack;
}

.fun-btn {
  width: 30px;
  display: inline-block;
  text-align: right;
  color: $LaleNotActiveGray;
  vertical-align: top;
  margin-bottom: 4px;

  i {
    font-size: 22px;
  }
}

.card-right-bottom {
  // margin-top: 5px;
}

.post-time {
  color: $LaleNotActiveGray;
  font-size: 14px;
}

.great-amount-div {
  color: $LalePrimary;
  text-align: right;
  font-size: 14px;
  img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
}

// 發文日期的寬度-年
.unit-year {
  .post-time {
    width: 174px;
  }

  .great-amount-div {
    width: calc(100% - 174px);
  }
}

// 發文日期的寬度-月
.unit-month {
  .post-time {
    width: 135px;
  }

  .great-amount-div {
    width: calc(100% - 135px);
  }
}

// 發文日期的寬度-小時/分鐘
.unit-big {
  .post-time {
    width: 110px;
  }

  .great-amount-div {
    width: calc(100% - 110px);
  }
}

.people-good-words {
  vertical-align: top;
}

// 小手機在 年/月 時就隱藏讚文字
@media (max-width: 320px) {
  .unit-month .people-good-words,
  .unit-year .people-good-words {
    display: none;
  }
}

.great-amount {
  vertical-align: top;
}

.others-p {
  font-weight: 700;
  color: #000;
}
</style>

<!-- 全域 css -->
<style lang="scss">
.post-card-bottom-sheet {
  .q-item__section--avatar {
    display: none !important;
  }

  .q-item__section--main {
    text-align: center;
  }

  .q-item {
    padding: 18px;
  }

  .q-item:not(:last-child) {
    border-bottom: 1px #eee solid;
  }
}

// 檢舉 dialog
.report-dialog {
  .q-btn-item:first-child .q-btn__content {
    color: $LaleTitleBlack;
  }
}
// 從相簿進入推高
.pushiOS {
  .fixed-bottom,
  .absolute-bottom {
    bottom: 6.5vh;
  }
}
</style>
